import { adminClient as apolloClient } from '@/store/apollo';

import TagsGql from '@/store/graphql/cms/queries/Tags.gql';

export default {
    fetchList: (cmsID = null) =>
        new Promise((resolve, reject) => {
            let variables = {};
            if (cmsID) variables.cms = parseInt(cmsID);

            apolloClient
                .query({
                    query: TagsGql,
                    variables
                })
                .then(({ data }) => resolve(data.CP_Tags))
                .catch(err => reject(err));
        })
};
